<div
  (taAncestorScroll)="open = false"
  [taAncestorScrollDisabled]="!open"
  [class.select__selection--invalid]="!valid && showValidation"
  #dropdownAnchor
>
  <!-- loading indicator -->
  <span *ngIf="loadingSelected"> <ta-icon icon="spinner" spin></ta-icon> </span>

  <!-- selected value -->
  <div>
    <span class="select__selected" *ngIf="!loadingSelected && value != null">
      <ng-template
        [ngTemplateOutlet]="selectedOptionLayoutTemplate"
        [ngTemplateOutletContext]="{ $implicit: selectedModel, model: selectedModel, myValue: value }"
      >
      </ng-template>
    </span>
  </div>

  <!-- placeholder -->
  <span *ngIf="value == null && placeholderLayout != null" class="">
    <ng-template
      [ngTemplateOutlet]="placeholderLayout.templateRef"
    ></ng-template>
  </span>
  <span
    *ngIf="value == null && placeholderLayout == null && placeholder != null"
    class="select__selected"
  >
    <span class="color--default">{{ placeholder }}</span>
  </span>

  <span
    *ngIf="clearable && value != null"
    (click)="clearValue($event)"
    [className]="selectClasses.clearButton"
    #clearValueButton
  ></span>

  <span class="select__arrow"> <ta-icon icon="down-dir"></ta-icon> </span>
</div>
